import React, { useState } from 'react';
import { Provider } from 'react-redux';
import store from '../../redux/store/store';

import ChatHolderComponent from 'react/chat/inner/display_pieces/ChatHolderComponent.jsx';
import ChatInputGroupComponent from 'react/chat/inner/display_pieces/ChatInputGroupComponent.jsx';
import { ChatRoomNameOverlay } from 'react/chat/inner/display_pieces/ChatRoomNameOverlay.jsx';
import ChatRoomDescriptionComponent from 'react/chat/inner/display_pieces/ChatRoomDescriptionComponent.jsx';
import { ChatMessages } from 'models/ChatMessages.jsx';
import { JqueryClassFaker } from '../../../components/JqueryClassFaker';
import UserlistComponent from '../userlist/UserlistComponent';
import ChatTabContainerComponent from '../ChatTabContainerComponent';
import { bindActionCreators } from "redux";
import { connect } from "react-redux";
import withDefaultProps from 'functions/withDefaultProps';
import getSelectedText from 'browser-selected-text';

function preventChatBrowserMenu(event) {
	if(event.target.closest('a[href], input, textarea, select, [contenteditable]:not([contenteditable="false"])') || getSelectedText()) {
		return;
	}
	event.preventDefault();
}

function ChatContainerComponent(incomingProps) {
	const props = withDefaultProps(incomingProps, defaultProps);

	function retrieveChatMessages() {
		const { chatRoom, chatMessages } = props;
		if(chatRoom) {
			return chatRoom.chatMessages;
		}
		else if(chatMessages) {
			return chatMessages;
		}
		else {
			return ChatMessages.create();
		}
	}

	function getChatHolderRef(chatHolderComponent) {

		const { chatRoom } = props;
		if(chatRoom) {

		}
		const chatMessages = retrieveChatMessages();
		chatMessages.setChatHolderComponent(chatHolderComponent);
	}


	const {
		isMinimized, showPersistentChatTabs, windowSizeIsMedium, windowSizeIsLarge,
		chatRoomGroups, showFatBottomBar,
		mainChatUserlistToggledOnSetting, chatRoom, name, mainChatUserlistToggle, isDisabled, isDisabledMessage, activePopupChatMessage,
		shouldFocusOnMount, showChatEmptyBanner, isActive, isPinned, worksOffNetplay,
	} = props;
	const chatOverlayShown = false;
	const chatMessages = retrieveChatMessages();

	if(!isActive) {
		return null;
	}


	let classes = new JqueryClassFaker();
	let key = '';
	if(chatRoom) {
		key += `chat-${chatRoom.id}`;
	}
	else if(!chatMessages.hasContext()) {
		classes.add('template_visible');
	}

	if(chatMessages.hasContext()) {
		key += `withContext`;
	}


	return (
		<div className={`chat_holder active ${classes.toString()}${isPinned ? ' pinned-mode' : ''}`} onContextMenu={preventChatBrowserMenu}>
			{mainChatUserlistToggledOnSetting &&
			<div id='user_list_side'>
				<div id='user_lists' className='list_holder user_lists'>
					{chatRoom && chatRoom.userlist &&
					<Provider store={store}>
						<UserlistComponent
							userlist={chatRoom.userlist}
							key={`userlist${key}`}
						/>
					</Provider>
					}
				</div>
			</div>
			}
			{!isMinimized && showPersistentChatTabs &&
			<div className='chat_tabs'>
				<div id='chat_groups_container'>
					<ChatTabContainerComponent
						active={windowSizeIsMedium || windowSizeIsLarge}
						chatRoomGroups={chatRoomGroups}
					/>
				</div>
			</div>
			}
			<div
				className='chat_side'
				onClick={isPinned && mainChatUserlistToggledOnSetting ? mainChatUserlistToggle : undefined}
			>
				<ChatRoomNameOverlay
					active={chatOverlayShown}
					name={name}
					key={`overlay${key}`}
				/>
				<ChatRoomDescriptionComponent
					chatRoom={chatRoom}
					active={!chatOverlayShown}
					description={chatRoom && chatRoom.description}
					key={`description${key}`}
				/>
				<ChatHolderComponent
					activePopupChatMessage={activePopupChatMessage}
					ref={getChatHolderRef}
					chatMessages={chatMessages}
					isDisabled={isDisabled}
					isDisabledMessage={isDisabledMessage}
					showChatEmptyBanner={showChatEmptyBanner}
					key={`holder${key}`}
				/>
				<Provider store={store}>
					<ChatInputGroupComponent
						canBeBottomAttached={showFatBottomBar}
						chatMessages={chatMessages}
						isDisabled={isDisabled}
						worksOffNetplay={worksOffNetplay}
						shouldFocusOnMount={shouldFocusOnMount}
						key={`input${key}`}
					/>
				</Provider>
			</div>
		</div>
	);
}

const defaultProps = {
	isActive: true,
	showFatBottomBar: true,
	shouldFocusOnMount: true
};

function mapStateToProps(state) {
	return {
		...state.chat,
		...state.windowFocus,
	};
}

function mapDispatchToProps(dispatch) {
	return bindActionCreators({}, dispatch);
}

export default connect(
	mapStateToProps,
	mapDispatchToProps
)(ChatContainerComponent);
